import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IoIosArrowForward } from 'react-icons/io';

import { handleTrackEvent } from 'utils/analytics';
import { useEvieAppContext } from '../EvieAppProvider';
import { useEvieHomeContext } from '../EvieHomeProvider';
import { HOME_STATUS, ACTIVITY_TYPES } from '../utils';

import './chat-program-card.scss';

const ChatProgramCard = ({ eventKey, eventType, eventTrigger }) => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { personalInfo: { dayContent = [] } = {} } = useEvieAppContext();
  const { changeHomeStatus, setActivityType, selectTask } = useEvieHomeContext();

  const handleGoToExercises = () => {
    const findSession = dayContent.find((exercise) => exercise.__typename === 'ProgramSessionExercise');
    selectTask(findSession);
    setActivityType(ACTIVITY_TYPES.EXERCISE);
    changeHomeStatus(HOME_STATUS.SESSION);
    handleTrackEvent('chat_action_clicked', { type: eventType, key: eventKey, trigger: eventTrigger });
    push(ROUTES.EVIE_HOME);
  };

  return (
    <button type="button" className="chat-program-card" onClick={handleGoToExercises}>
      <div className="chat-program-card__icon">
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" stroke="#9b2c51" strokeWidth="1.8" />
          <path d="M3.5 9.5h17" stroke="#9b2c51" strokeWidth="1.8" />
          <path d="M8 3v3.5M16 3v3.5" stroke="#9b2c51" strokeWidth="1.8" strokeLinecap="round" />
          <path
            d="M12 17.4s-2.9-1.8-2.9-3.6c0-.9.7-1.7 1.6-1.7.6 0 1 .3 1.3.8.3-.5.7-.8 1.3-.8.9 0 1.6.8 1.6 1.7 0 1.8-2.9 3.6-2.9 3.6z"
            fill="#9b2c51"
          />
        </svg>
      </div>
      <h3 className="chat-program-card__title">{t('evieApp.chatActions.todaySession.title')}</h3>
      <IoIosArrowForward className="chat-program-card__chevron" size={22} />
    </button>
  );
};

ChatProgramCard.defaultProps = {
  eventKey: '',
  eventType: '',
  eventTrigger: '',
};

ChatProgramCard.propTypes = {
  eventKey: PropTypes.string,
  eventType: PropTypes.string,
  eventTrigger: PropTypes.string,
};

export default ChatProgramCard;
